import PropTypes from 'prop-types';
import React from 'react';
import T from 'components/T';
import { i18n } from '@international/mastodon-i18n';
import { EducationDegreeArray } from '../../../../../types/report';
import {
  ReportTable,
  ReportTableBody,
  ReportTableCell,
  ReportTableHead,
  ReportTableRow,
  ReportTableRowLabel,
} from 'components/Reports/Report/MastodonReport/ReportTable';
import EducationTableTitle from './EducationTableTitle';

interface EducationDegreeProps {
  degree: EducationDegreeArray;
  index: number;
}

const EducationDegree = ({ degree, index }: EducationDegreeProps) => {
  return (
    <ReportTable small>
      <ReportTableHead>
        <ReportTableRow>
          <EducationTableTitle>
            <T value='components.education.verifiedDegree' index={index + 1} />
          </EducationTableTitle>
        </ReportTableRow>
      </ReportTableHead>

      <ReportTableBody>
        {[
          {
            name: 'title',
            title: i18n.getStr('components.education.degreeLevel'),
          },
          {
            name: 'majors',
            title: i18n.getStr('components.education.majors'),
          },
          {
            name: 'majorConcentrations',
            title: i18n.getStr('components.education.concentrations'),
          },
          {
            name: 'minors',
            title: i18n.getStr('components.education.minors'),
          },
          {
            name: 'yearAwarded',
            title: i18n.getStr('components.education.yearAwarded'),
          },
        ].map((field: { name: string; title: string }, i) => (
          <ReportTableRow key={`tr-${i + 1}`}>
            <ReportTableRowLabel className='text-very-muted column-6'>
              {field.title}
            </ReportTableRowLabel>
            <ReportTableCell className='column-6'>
              {degree[field.name] || '-'}
            </ReportTableCell>
          </ReportTableRow>
        ))}
      </ReportTableBody>
    </ReportTable>
  );
};

EducationDegree.propTypes = {
  degree: PropTypes.object.isRequired,
  index: PropTypes.number.isRequired,
};

export default EducationDegree;
